/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PostTourRequest } from '../../models/post-tour-request';
import { TourResponse } from '../../models/tour-response';

export interface UpdateTour$Params {
  organizationSiteKey: KeyType;
  tourKey: KeyType;
      body: PostTourRequest
}

export function updateTour(http: HttpClient, rootUrl: string, params: UpdateTour$Params, context?: HttpContext): Observable<StrictHttpResponse<TourResponse>> {
  const rb = new RequestBuilder(rootUrl, updateTour.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('tourKey', params.tourKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TourResponse>;
    })
  );
}

updateTour.PATH = '/organization-sites/{organizationSiteKey}/carrier/tours/{tourKey}';
